import * as React from 'react';
import { SVGProps } from 'react';

const IconSelectOpenSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.5 15 12 9l5.5 6h-11z" />
  </svg>
);

export default IconSelectOpenSizeM;
